app.directive('imagePositioner', ['$window', function ($window) {
	return {
		restrict: 'A',
		link: function(scope, element, attrs){
			var rightColumn = null;
			var imageColumn = null;

			angular.element($window).bind('load resize', function(){
				scope.updateColumn();
			});

			scope.updateColumn = function() {
				if ($window.innerWidth < 768) {
					imageColumn = document.querySelector('.slides-text-image-right__image');
					imageColumn.style.height = "";
				} else  {

					rightColumn = document.querySelector('.slides-text-image-right');
					imageColumn = document.querySelector('.slides-text-image-right__image');

					var imageElement = document.querySelector('.slides-text-image-right__image img');
					var imageHeight = parseInt(imageColumn.style.height);

					if (isNaN(imageHeight)) {
						imageColumn.style.height = imageElement.naturalHeight + 'px';
						imageHeight = parseInt(imageColumn.style.height);
					}
					if (rightColumn.offsetHeight > imageHeight || !imageHeight) {
						imageColumn.style.height = rightColumn.offsetHeight + 'px';
					}
				}
			};
		}
	};
}]);